import {
   SET_USER,
   SET_ERROR,
   CLEAR_ERROR,
   SET_LOADING,
   STOP_LOADING,
   SET_MESSAGE
  } from "./types";
  
  import UserService from "../../services/user.service";
  import { getUserDetails, logout } from "./auth";

  export const updateUser = (data) => (dispatch) => {
    dispatch({
        type: CLEAR_ERROR,
      });
      

    return UserService.updateUser(data).then(
      (response) => {
        console.log(response)
        dispatch({
          type: SET_USER,
          payload: response,
        });
        dispatch(getUserDetails());
        return Promise.resolve();
      },
      (error) => {
  
        dispatch({
          type: SET_ERROR,
        });
  
        return Promise.reject();
      }
    );
  };

  export const applyLoan = (data) => (dispatch) => {
    return UserService.applyLoan(data).then(
      (response) => {
        dispatch({
          type: SET_MESSAGE,
          payload: response
        });
        return response
      },
      (error) => {
        if(error && error.response && error.response.data && !error.response.data.isAuth ){
          dispatch(logout())
          dispatch({
            type: SET_MESSAGE,
            payload: {message: 'Session Expired!', type: 'error'}
          });
      }
      
        return
      }
    );
  };

  export const setPersonalDetails = (data) => (dispatch) => {
    dispatch({
        type: CLEAR_ERROR,
      });

      dispatch({
        type: SET_LOADING,
      });
    return UserService.setPersonalDetails(data).then(
      (response) => {
        console.log(response)
        dispatch({
          type: SET_USER,
          payload: { personalDetails: response},
        });
        dispatch(getUserDetails());
        dispatch({
          type: STOP_LOADING,
        });
        return Promise.resolve();
      },
      (error) => {
  
        dispatch({
          type: SET_ERROR,
        });
        dispatch({
          type: STOP_LOADING,
        });
        return Promise.reject();
      }
    );
  };

  export const setLocation = (data) => (dispatch) => {
    dispatch({
        type: CLEAR_ERROR,
      });

      dispatch({
        type: SET_LOADING,
      });

    return UserService.setLocation(data).then(
      (response) => {
        console.log(response)
        dispatch({
          type: SET_USER,
          payload: { location: response},
        });
        dispatch(getUserDetails());

      dispatch({
        type: STOP_LOADING,
      });

        return Promise.resolve();
      },
      (error) => {
  
        dispatch({
          type: SET_ERROR,
        });

        dispatch({
          type: STOP_LOADING,
        });

        return Promise.reject();
      }
    );
  };


  export const addFileRef = (data, types) => async (dispatch) => {
    dispatch({
        type: CLEAR_ERROR,
      });
      dispatch({
        type: SET_LOADING,
      });
      console.log(types)
    return await UserService.addFileRef(data, types).then(
      (response) => {
        console.log(response)
        dispatch({
          type: SET_USER,
          payload: { personalDetails: { [types]:  response.url } },
        });
        dispatch(getUserDetails());
        dispatch({
          type: STOP_LOADING,
        });

        return response
      },
      (error) => {
        console.log(error.response)
        if(error && error.response && error.response.data && !error.response.data.isAuth ){
            dispatch(logout())
            dispatch({
              type: SET_MESSAGE,
              payload: {message: 'Session Expired!', type: 'error'}
            });
        }
        dispatch({
          type: STOP_LOADING,
        });
        return Promise.reject();
      }
    );
  };



  export const uploadUserImage = (data, type) => async (dispatch) => {
    dispatch({
        type: CLEAR_ERROR,
      });
      dispatch({
        type: SET_LOADING,
      });
      
    return await UserService.addFileRef(data, type).then(
      (response) => {
        console.log(response)
        dispatch({
          type: SET_USER,
          payload: { personalDetails: { [type]:  response.url } },
        });
        dispatch({
          type: STOP_LOADING,
        });

        return response
      },
      (error) => {
     
        dispatch({
          type: STOP_LOADING,
        });
        return Promise.reject();
      }
    );
  };

  export const cashRequest = (type, data) => (dispatch) => {
    console.log(data);
    dispatch({
      type: SET_LOADING,
    });
    dispatch({
      type: CLEAR_ERROR,
    });
    return UserService.cashRequest(type, data).then(
      (response) => {
        console.log(response)
        dispatch({
          type: SET_MESSAGE,
          payload: response
        });
        dispatch({
          type: STOP_LOADING,
        });
        return true
      },
      (error) => {
        console.log(error.response)
        dispatch({
          type: SET_ERROR,
          payload: error.response.data
        });

        dispatch({
          type: STOP_LOADING,
        });
        if(error && error.response && error.response.data && error.response.data.isAuth === false ){
          dispatch({
            type: SET_MESSAGE,
            payload: {message: 'Session Expired!', type: 'error'}
          });
          dispatch(logout())
      }
        return false
      }
    );
  };

  export const uploadImage = (data) => (dispatch) => {
    console.log(data);
    dispatch({
        type: CLEAR_ERROR,
      });
    return UserService.uploadImage(data).then(
      (response) => {
        return response.url;
      },
      (error) => {
        dispatch({
          type: SET_ERROR,
        });
        return Promise.reject();
      }
    );
  };

